import axios from 'axios';

const apiPlaca = axios.create({
  baseURL:
    process.env.REACT_APP_ENVIRONMENT === 'dev'
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD,
});

apiPlaca.defaults.validateStatus = () => {
  return true;
};

export default apiPlaca;
